import script from "./SemiCustomLightJacket.vue?vue&type=script&setup=true&lang=js"
export * from "./SemiCustomLightJacket.vue?vue&type=script&setup=true&lang=js"

import "./SemiCustomLightJacket.vue?vue&type=style&index=0&id=38705506&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\karuizawa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38705506"]])

export default __exports__